<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-fixed"
    :class="{
      [`md-${type}`]: !navbarTransparent,
      [extraNavClasses]: navbarTransparent,
      'md-transparent': navbarTransparent
    }"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <h3 class="md-title" id="brand-heading">
          <router-link :to="{name: 'home'}">
            <img :src="aerLogo" :alt="brand">
          </router-link>
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar" />
          <span class="icon-bar" />
          <span class="icon-bar" />
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <li class="md-list-item">
                <router-link :to="{name:'find-engineer'}"
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content">
                    <md-button
                      slot="title"
                      class="md-button md-button-link md-white md-simple"
                    >
                      <i class="material-icons">search</i>
                      <p>Find an Engineer</p>
                    </md-button>
                  </div>
                </router-link>
              </li>
              <li class="md-list-item">
                <router-link :to="{name:'join'}"
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content">
                    <md-button
                      slot="title"
                      class="md-button md-button-link md-white md-simple"
                    >
                      <i class="material-icons">assignment</i>
                      <p>Join AER</p>
                    </md-button>
                  </div>
                </router-link>
              </li>

              <li class="md-list-item">
                <router-link :to="{name:'login'}"
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content" v-if="!isLoggedIn">
                    <md-button
                      class="md-primary"
                    >
                      <md-icon>login</md-icon> Log In
                    </md-button>
                  </div>
                  <div class="md-list-item-content" v-else>
                    <md-button
                      class="md-primary"
                    >
                      <md-icon>account_circle</md-icon> My Profile
                    </md-button>
                  </div>
                </router-link>
              </li>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            actualResizeHandler();

            // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
    }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
    components: {
        MobileMenu
    },
    props: {
        type: {
            type: String,
            default: "primary",
            validator(value) {
                return [
                    "white",
                    "default",
                    "primary",
                    "danger",
                    "success",
                    "warning",
                    "info",
                    "dark"
                ].includes(value);
            }
        },
        colorOnScroll: {
            type: Number,
            default: 0
        },
        navbarTransparent: {
            type: Boolean,
            default: false
        },
        loggedIn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            extraNavClasses: "",
            toggledClass: false,
            brand: "ASEAN Engineers Register",
            aerLogo: require("@/assets/img/logo.png")
        };
    },
    computed: {
      isLoggedIn() {
        var loggedIn = this.$store.getters['isLoggedIn'];
        return this.$store.getters['isLoggedIn'];
      }
    },
    mounted() {
        document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.scrollListener);
    },
    methods: {
        bodyClick() {
            let bodyClick = document.getElementById("bodyClick");

            if (bodyClick === null) {
                let body = document.querySelector("body");
                let elem = document.createElement("div");
                elem.setAttribute("id", "bodyClick");
                body.appendChild(elem);

                let bodyClick = document.getElementById("bodyClick");
                bodyClick.addEventListener("click", this.toggleNavbarMobile);
            } else {
                bodyClick.remove();
            }
        },
        toggleNavbarMobile() {
            this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
            this.toggledClass = !this.toggledClass;
            this.bodyClick();
        },
        handleScroll() {
            let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
            let navbarColor = document.getElementById("toolbar");
            this.currentScrollValue = scrollValue;
            if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
                this.extraNavClasses = `md-${this.type}`;
                navbarColor.classList.remove("md-transparent");
            } else {
                if (this.extraNavClasses) {
                    this.extraNavClasses = "";
                    navbarColor.classList.add("md-transparent");
                }
            }
        },
        scrollListener() {
            resizeThrottler(this.handleScroll);
        }
    }
};
</script>
